"use client";

import { c as _c } from "react/compiler-runtime";
import { useChatbotVisibility } from "./chatbot-experiment";
import { LazyChatBotButton } from "./lazy-chat-bot-button";
import { useChatBotNavigation } from "./navigation";
import { trackChatbotIconClicked } from "./tracking";
type ChatBotExperimentFloatingButtonProps = {
  downloadAppToastHeight?: number;
};
const CHATBOT_DYNAMIC_PADDING = "bottom-[calc(76px+24px+16px)]";
export const ChatBotExperimentFloatingButton = t0 => {
  const $ = _c(5);
  const {
    downloadAppToastHeight: t1
  } = t0;
  const downloadAppToastHeight = t1 === undefined ? 0 : t1;
  const visible = useChatbotVisibility();
  const navigation = useChatBotNavigation();
  if (visible !== true) {
    return null;
  }
  const t2 = `fixed left-6 right-auto z-30 md:bottom-6 ${downloadAppToastHeight ? CHATBOT_DYNAMIC_PADDING : "bottom-6"}`;
  let t3;
  if ($[0] !== navigation) {
    t3 = <LazyChatBotButton onClick={() => {
      trackChatbotIconClicked("chatbot_icon");
      navigation.open();
    }} />;
    $[0] = navigation;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};